module.exports = __webpack_public_path__ + "media/Loops Vocals.e7a8afec.wav";